import React, { useEffect, useState } from "react";
import { awsSignIn, authData } from "../../redux/auth/authSlice";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import UserHeader from "../Header/UserHeader/UserHeader";
import "../HomeScreen/Dashboard/dashboard.scss";
import { FaBars } from "react-icons/fa";
import {
  Button,
  styled,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { API } from "aws-amplify";
import config from "../../config/aws-exports";
import { Constants } from "../../config/constants";
import User from "./Hallticket.module.scss";
import { Document, Page, pdfjs } from "react-pdf";
import { debounce } from "lodash";
import Skeleton from "@material-ui/lab/Skeleton";

// Set the workerSrc for react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .slick-arrow": {
      color: "black",
    },
    "& .slick-prev:before": {
      color: "black",
      fontSize: 27,
    },
    "& .slick-next:before": {
      color: "black",
      fontSize: 27,
    },
    "& .MuiGrid-root": {},
    "& .MuiGrid-item": {},
    "& .MuiGrid-grid-xs-6": {},
  },
  mainGrid: {
    width: "100%",
    margin: 0,
    "& > div": {
      padding: "15px!important",
    },
  },
  AssessmentpieChartStyle: {
    "& > div ": {
      overflow: "auto",
    },
    "& > div > div > div > div > svg": {
      width: "100vw!important",
    },
  },
  IDButton: {
    border: "1px solid var(--sub-heading-color) !important",
    color: "var(--sub-heading-color) !important",
    textTransform: "capitalize!important",
    gap: "1rem",
    fontSize: "1.4rem!important",
    width: "10rem",
    marginLeft: "auto!important",
  },
  joinNowButton: {
    backgroundColor: "var(--sub-heading-color) !important",
    textTransform: "capitalize!important",
    width: "10rem",
    height: "40px",
    fontSize: "1.5rem!important",
    border: "none",
    color: "white!important",
    borderRadius: "4px",
  },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialog-paper": {
    width: "80%",
    maxWidth: "800px",
    backgroundColor: "#efefef",
    "@media (max-width: 1025px)": {
      maxWidth: "90%",
      margin: "1rem",
    },
  },
}));

const Hallticket = ({ handleToggleSidebar }) => {
  const userDetails = useSelector(authData);
  const classes = useStyles();
  const [openItem, setOpenItem] = useState(false);
  const [certificate, setCertificate] = useState([]);
  const [currentFile, setCurrentFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hallticket, setHallticket] = useState([]);
  const [numPages, setNumPages] = useState(null); // State to store number of pages
  const [error, setError] = useState(null);

  useEffect(() => {
    getUsersDetails();
  }, []);

  async function getUsersDetails() {
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        eid: userDetails.eid,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    setLoading(true);
    setError(null);
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/getHallticket",
        bodyParam
      );
      const users = response.body;
      console.log("API response:", users);
      setCertificate(users[0]?.cert || []);
      setHallticket(users?.hallticketInfo || []);
    } catch (error) {
      console.error("getUserError", error);
      setCertificate([]);
      setHallticket([]);
      setError("Failed to fetch hall tickets. Please try again later.");
    }
    setLoading(false);
  }

  const handleDownload = debounce(async (fileUrl) => {
    if (!fileUrl) {
      console.error("No file URL provided");
      return;
    }
    console.log("Initiating download for:", fileUrl);
    try {
      const response = await fetch(fileUrl, { method: "GET", mode: "cors" });
      if (!response.ok) {
        throw new Error(`Download failed: ${response.statusText}`);
      }
      const blob = await response.blob();
      const link = document.createElement("a");
      const blobUrl = URL.createObjectURL(blob);
      link.href = blobUrl;
      link.download = fileUrl.split("/").pop() || "hallticket";
      link.click();
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading file:", error);
      setError("Failed to download file. Please try again.");
    }
  }, 500);

  const handleClickOpenItem = (hall) => {
    setCurrentFile(hall);
    setOpenItem(true);
  };

  const handleCloseItem = () => {
    setOpenItem(false);
    setCurrentFile(null);
    setNumPages(null); // Reset number of pages when closing
  };

  const getFileType = (url) => {
    const extension = url.split(".").pop().toLowerCase();
    return ["pdf"].includes(extension)
      ? "pdf"
      : ["png", "jpeg", "jpg"].includes(extension)
      ? "image"
      : "unknown";
  };

  // Callback to set the number of pages when PDF is loaded
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  function programlist() {
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "3rem",
          padding: "2.5rem",
        }}
      >
        {hallticket && hallticket.length > 0 ? (
          hallticket.map((hall, index) => {
            const fileUrl = `https://${
              Constants.DOMAIN
            }/${config.aws_org_id.toLowerCase()}-data/data/hallticket/${
              hall.bpid
            }/${hall.hallticketName}`;
            const fileType = getFileType(hall.hallticketName);

            const path = hall.hallticketName;
            const fileName = path.substring(path.lastIndexOf("/") + 1);

            return (
              <div
                key={index}
                className={`${User.mainsection}`}
                style={{
                  width: "40%",
                  maxWidth: "400px",
                  border: "3px solid var(--sub-heading-color)",
                  borderRadius: "3px",
                  padding: "1rem",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "16rem",
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {fileType === "pdf" ? (
                    <Document
                      file={fileUrl}
                      onLoadSuccess={onDocumentLoadSuccess}
                      onLoadError={(error) =>
                        console.error("PDF load error:", error)
                      }
                    >
                      <Page pageNumber={1} width={128} />
                    </Document>
                  ) : (
                    <img
                      src={fileUrl}
                      alt={hall.hallticketName}
                      style={{
                        width: "8rem",
                        height: "8rem",
                        objectFit: "cover",
                      }}
                      onError={(e) => console.error("Image load error:", e)}
                    />
                  )}
                </div>
                <p
                  style={{
                    marginTop: "0.5rem",
                    fontSize: "0.875rem",
                    textAlign: "center",
                    fontWeight: "500",
                  }}
                >
                  {fileName}
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "1rem",
                    marginTop: "1rem",
                  }}
                >
                  <Button
                    className={classes.IDButton}
                    onClick={() => handleClickOpenItem(hall)}
                  >
                    Preview
                  </Button>
                  <Button
                    className={classes.joinNowButton}
                    onClick={() => handleDownload(fileUrl)}
                  >
                    Download
                  </Button>
                </div>
              </div>
            );
          })
        ) : (
          <div
            style={{
              fontSize: "1.125rem",
              fontWeight: "700",
              width: "100%",
              textAlign: "center",
              color: "#f44336",
            }}
          >
            No Hall Tickets Available
          </div>
        )}
      </div>
    );
  }

  return (
    <main>
      <div
        className="btn-toggle"
        onClick={() => handleToggleSidebar(true)}
        style={{ cursor: "pointer" }}
      >
        <FaBars />
      </div>
      <UserHeader />
      <div>
        {error ? (
          <div
            style={{
              fontSize: "1.125rem",
              fontWeight: "700",
              width: "100%",
              textAlign: "center",
              color: "#f44336",
            }}
          >
            {error}
          </div>
        ) : (
          <div style={{ minHeight: "100vh" }}>
            <h2
              style={{
                fontSize: "1.5rem",
                fontWeight: "700",
                paddingLeft: "2.5rem",
                paddingTop: "1.25rem",
              }}
            >
              Hall Tickets
            </h2>
            {loading ? (
              <div>
                <Typography component="list" variant="h1">
                  <Skeleton />
                </Typography>

                <Typography component="list" variant="h1">
                  <Skeleton />
                </Typography>
                <Typography component="list" variant="h1">
                  <Skeleton />
                </Typography>
                <Typography component="list" variant="h1">
                  <Skeleton />
                </Typography>
              </div>
            ) : (
              <div className={classes.root}>{programlist()}</div>
            )}
          </div>
        )}
      </div>

      <BootstrapDialog
        onClose={handleCloseItem}
        aria-labelledby="customized-dialog-title"
        open={openItem}
      >
        <DialogTitle
          sx={{ m: 0, p: 2, fontSize: "1.5rem" }}
          id="customized-dialog-title"
        >
          {currentFile?.hallticketName.substring(
            currentFile?.hallticketName.lastIndexOf("/") + 1
          )}
          {/* {currentFile?.hallticketName || "File Preview"} */}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseItem}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent
          sx={{
            padding: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {currentFile && getFileType(currentFile.hallticketName) === "pdf" ? (
            <Document
              file={`https://${
                Constants.DOMAIN
              }/${config.aws_org_id.toLowerCase()}-data/data/hallticket/${
                currentFile.bpid
              }/${currentFile.hallticketName}`}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={(error) =>
                console.error("PDF preview error:", error)
              }
            >
              {numPages &&
                Array.from({ length: numPages }, (_, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    width={600}
                    style={{ marginBottom: "1rem" }}
                  />
                ))}
            </Document>
          ) : (
            <img
              src={`https://${
                Constants.DOMAIN
              }/${config.aws_org_id.toLowerCase()}-data/data/hallticket/${
                currentFile?.bpid
              }/${currentFile?.hallticketName}`}
              alt={currentFile?.hallticketName}
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "60vh",
                objectFit: "contain",
              }}
              onError={(e) => console.error("Image preview error:", e)}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.joinNowButton}
            onClick={() =>
              handleDownload(
                `https://${
                  Constants.DOMAIN
                }/${config.aws_org_id.toLowerCase()}-data/data/hallticket/${
                  currentFile?.bpid
                }/${currentFile?.hallticketName}`
              )
            }
          >
            Download
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </main>
  );
};

export default Hallticket;
